import { render, staticRenderFns } from "./OchinApp.vue?vue&type=template&id=246a4b56"
import script from "./OchinApp.vue?vue&type=script&lang=js"
export * from "./OchinApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports